import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '../../Generic/Carousel';
import RelatedCollections from '../RelatedCollection/RelatedCollection';
import styles from '../RelatedCollection/RelatedCollection-tw-styles';

const settings = {
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  speed: 600,
  adaptiveHeight: false,
  infinite: false,
  lazyLoad: false,
  dots: true,
  draggable: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: <span className="glyphicon glyphicon-menu-left" />,
  nextArrow: <span className="glyphicon glyphicon-menu-right" />,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        dots: true,
        draggable: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
      },
    },
  ],
};

export default class CollectionCarousel extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const { contentData, locale } = this.props;
    return (
      <div className={styles.collectionCarouselParent}>
        <Carousel {...settings} className={styles.collectionCarouselCardWidth}>
          {contentData &&
            contentData.relatedCollectionsCollection &&
            contentData.relatedCollectionsCollection.items.map(
              collectionpage => {
                return (
                  <div
                    className={styles.collectionRelatedProdDiv}
                    key={collectionpage.sys.id}
                  >
                    <RelatedCollections
                      key={collectionpage.sys.id}
                      data={collectionpage}
                      locale={locale}
                    />
                  </div>
                );
              }
            )}
        </Carousel>
      </div>
    );
  }
}

CollectionCarousel.propTypes = {
  collectionpage: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string.isRequired,
};
